'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

exports.default = (0, _themeSections.register)('template-page-contact', {
  onLoad: function onLoad() {
    setTimeout(function () {
      if (window.location.hash === '#contact_form' || window.location.href.indexOf("contact_posted") > -1) {
        $('html, body').animate({ scrollTop: 0 }, 500);
      }
    }, 1500);
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {}
});